<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">
        <h4>试题设置</h4>
        <div class="dialogclose">
          <img
            src="@/assets/dialogimg/dialogclose.png"
            alt=""
            @click="cancel"
          />
        </div>
      </div>
      <div class="dialog-body">
        <div class="testtypebutton">
          <!-- 切换按钮 -->
          <button
            class="testtypebtn"
            :class="{ isactivetype: testtype === '0' }"
            @click="changetesttype('0')"
          >
            平台题库
          </button>
          <button
            class="testtypebtn"
            :class="{ isactivetype: testtype === '1' }"
            @click="changetesttype('1')"
            v-if="testmode !== '难易度组卷'"
          >
            自定义题库
          </button>
          <button
            class="testtypebtn"
            :class="{ isactivetype: testtype === '2' }"
            @click="changetesttype('2')"
            v-if="testmode !== '难易度组卷'"
          >
            收藏题库
          </button>
        </div>
        <!-- 穿梭框选择题库功能 -->
        <div class="question_contents">
          <div class="questions">
            <div class="titlecontent">
              <h4>所有题库</h4>
              <!-- 搜索题库 11.23新增功能 -->
              <div class="query">
                <!-- <el-input v-model.trim="queryTitle"></el-input
                ><el-button @click="queryClick">搜索</el-button> -->
                <!-- <el-button @click="filterfn">重置</el-button> -->
                <el-cascader
                  :options="option"
                  :props="props"
                  :key="testtype"
                  v-model="val"
                  ref="cascader"
                  clearable
                  class="taansferssss"
                  popper-class="tranoptions"
                  @change="changda($event)"
                  @expand-change="fn($event)"
                  filterable
                  :collapse-tags="true"
                ></el-cascader>
              </div>
            </div>
            <div class="resreach">
              <div class="resreach_item">全部系列</div>
              <div class="resreach_item">全部类别</div>
              <div class="resreach_item resreach_item3">全部科目</div>
              <div class="resreach_item4"></div>
              <!-- <el-input
                v-model="input"
                placeholder="暂时先用这个吧，后边再改"
              ></el-input> -->
              <!-- <el-tag>系列</el-tag>
              <el-tag type="success">类别</el-tag>
              <el-tag type="warning">科目</el-tag> -->
            </div>
            <el-cascader-panel
              :options="option"
              :props="props"
              :key="testtype"
              v-model="val"
              ref="cascader"
              clearable
              class="taansfer"
              @change="changda($event)"
              @expand-change="fn($event)"
            ></el-cascader-panel>
            <div v-if="queryState == 2" class="null_view">暂无数据</div>
          </div>
          <div class="question">
            <img src="../../../../../../assets/transferbtn.png" alt="" />
          </div>
          <div class="questions questionsyixuan">
            <div class="titlecontent">
              <h4>已选题库</h4>
            </div>
            <div class="resreach">
              <div class="resreach_item">已选系列</div>
              <div class="resreach_item">已选类别</div>
              <div class="resreach_item resreach_item3">已选科目</div>
              <div class="resreach_item4"></div>
              <!-- <el-tag>已选系列</el-tag>
              <el-tag type="success">已选类别</el-tag>
              <el-tag type="warning">已选科目</el-tag> -->
              <!-- <el-input
                v-model="input"
                placeholder="暂时先用这个吧1，后边再改"
              ></el-input> -->
            </div>
            <el-cascader-panel
              :key="propKey"
              :options="vals"
              :props="props2"
              v-model="props2val"
              ref="cascader"
              @change="propschange($event)"
              clearable
            ></el-cascader-panel>
          </div>
        </div>
        <div class="operation_btn">
          <el-button type="success" @click="back">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import totype from "@/utils/transfer";
import { times } from "@/mixin/time";
import { searchApp } from "@/api/index.js";
import loginvuex from "@/store/index";
import { array } from "js-md5";
export default {
  data() {
    return {
      propKey: "1",
      dialogVisible: false,
      testtype: "", //1是平台题库，0是自定义题库，2是收藏题库
      localStorageResouce: "", //缓存源 主要是两个地方，alltestbank和testbank
      isdialogVisible: "", //打开题库弹窗时的状态。1代表是在权限管理里面打开
      input: "",
      props: {
        multiple: true,
        value: "AppClassName",
        label: "AppClassName",
        emitPath: true,
      }, //是否多选 左边
      modelval: {},
      props2: {
        multiple: true,
        value: "label",
        label: "label",
        emitPath: true,
      }, //是否多选 右边
      val: [], //选中的数据
      props2val: [], //第二个级联选中的数据
      vals: [], //穿梭给第二个级联的数据
      option: [],
      queryTitle: "", // 查询题目
      outeKey: "", // 当前处于那个系列
      queryState: 0, // 查询状态 0级联数据 1查询结构 2空
      checkedCities: [], // 查询出来的多选框---> 选中
      checkAll: false, // 查询出来的多选框 全选状态
      cities: [], // 查询出来的多选框
      isIndeterminate: true,
      testmode: null,
      options: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
      checkOptions: [], // 查询用于展示的结果
    };
  },
  mixins: [times], // 引入共用方法
  methods: {
    changda(e) {
      //选中节点的值
      //左边数据汇总到右边，右边分发记点，记分再分发到各个左边。
      // console.log(
      //   "CheckedNodes=========",
      //   this.$refs["cascader"].getCheckedNodes(false)
      // );

      if (this.modelval[`${this.testtype}`] === undefined) {
        this.modelval[`${this.testtype}`] = [];
        this.modelval[`${this.testtype}`] = this.val;
      } else {
        this.modelval[`${this.testtype}`] = this.val;
      }
      let tiemer = setTimeout(() => {
        let newarr = Object.values(this.modelval).flat(1);
        this.props2val = Object.values(this.modelval).flat(1);
        this.vals = totype.zhuanhuan(newarr);
        clearTimeout(tiemer);
      }, 300);
    },
    propschange() {
      // if(this.modelval[`${this.testtype}`] === undefined){
      //   this.modelval[`${this.testtype}`] = [];
      //   this.modelval[`${this.testtype}`] = this.props2val
      // }else{
      //   this.modelval[`${this.testtype}`] = this.props2val
      // }
      //判断是否有自定义题库的选中
      let alltestQusetion = Object.keys(this.modelval);
      if (alltestQusetion.includes("0")) {
        this.modelval["0"] = this.props2val.filter((item) => {
          return item[0] !== "自定义题库" || item[0] !== "收藏题库";
        });
      }
      if (alltestQusetion.includes("1")) {
        this.modelval["1"] = this.props2val.filter((item) => {
          return item[0] == "自定义题库";
        });
      }
      if (alltestQusetion.includes("2")) {
        this.modelval["2"] = this.props2val.filter((item) => {
          return item[0] == "收藏题库";
        });
      }
      this.val = this.modelval[`${this.testtype}`];
      //  this.props2val  = JSON.parse(JSON.stringify(this.val))
      let tiemer = setTimeout(() => {
        let newarr = Object.values(this.modelval).flat(1);
        //    this.props2val = Object.values(this.modelval).flat(1)
        this.vals = totype.zhuanhuan(newarr);
        this.propKey = Math.floor(Math.random() * (9999 - 1000)) + 1000;
        clearTimeout(tiemer);
      }, 300);
    },
    cancel() {
      this.dialogVisible = !this.dialogVisible;
      this.queryTitle = "";
    },
    softapprrefer(soft) {
      let first = {};
      soft.forEach((itema, index) => {
        first[soft[index].label + "|" + soft[index].AppClassID] = {};
        soft[index].children.map((item) => {
          first[soft[index].label + "|" + soft[index].AppClassID][
            item.label + "|" + item.AppClassID
          ] = [];
          let threed = item.children.map((items) => {
            return (
              items.AppEName +
              "|" +
              items.AppID +
              "|" +
              items.label +
              "|" +
              item.label +
              "|" +
              item.AppClassID
            );
          });
          first[soft[index].label + "|" + soft[index].AppClassID][
            item.label + "|" + item.AppClassID
          ].push(threed);
        });
      });
      return first;
    },
    changetesttype(type) {
      // if (this.testtype !== type) {
      //   if (this.testtype === "1") {
      //     //自定义题库
      //     this.testtype = "0";
      //   } else {
      //     //平台题库
      //     this.testtype = "1";
      //   }
      // }
      this.queryState = 0; // 显示源数据
      this.queryTitle = ""; // 清空查询条件
      this.testtype = type;
    },
    back() {
      this.dialogVisible = false;
      this.queryTitle = "";
    },
    submit() {
      if (this.val.length != 0) {
        this.dialogVisible = false;
        // 选择完题开始计时
        if (this.overTimerState == false) {
          this.overTimerState = true;
          this.timeIsaddtest();
        }
        // if (this.$parent.timeIsaddtest) {
        //   this.$parent.timeIsaddtest();
        // }
      } else {
        this.$message({
          message: "必须要勾选一个题库",
          type: "warning",
        });
        return;
      }
      this.$parent.isaddtest = false;
      let selectarr = []; //发送的数据
      //从全部数组内抽取到
      let alltestArr = JSON.parse(
        localStorage.getItem(this.localStorageResouce)
      );
      let isouhe = alltestArr.map((item, index) => {
        let isselectindex = this.vals.findIndex((items) => {
          return items.label == item.AppClassName;
        });
        if (isselectindex != -1) {
          return index;
        } else {
          return "";
        }
      });
      isouhe = isouhe.filter((item) => {
        return item !== "";
      });
      for (let x = 0; x < isouhe.length; x++) {
        const clonearr = JSON.stringify(alltestArr[isouhe[x]]);
        const afterclonearr = JSON.parse(clonearr);
        selectarr.push(afterclonearr); //第一层数据
        selectarr[x].children = [];
        console.log(this.vals[x], alltestArr[isouhe[x]]);
        this.vals[x].AppClassID = alltestArr[isouhe[x]].AppClassID;
        for (let i = 0; i < alltestArr[isouhe[x]].children.length; i++) {
          let a = this.vals[x].children.filter((item, index) => {
            //这里面改造第三级别的数据了。
            // 开始第三圈
            // console.log(
            //   alltestArr[isouhe[x]].children[i].AppClassName,
            //   item.label,
            //   "选中ID"
            // );
            if (alltestArr[isouhe[x]].children[i].AppClassName === item.label) {
              item.AppClassID = alltestArr[isouhe[x]].children[i].AppClassID;
              for (
                let b = 0;
                b < alltestArr[isouhe[x]].children[i].children.length;
                b++
              ) {
                item.children.map((zitem) => {
                  if (
                    alltestArr[isouhe[x]].children[i].children[b]
                      .AppClassName === zitem.label
                  ) {
                    zitem.AppEName =
                      alltestArr[isouhe[x]].children[i].children[b].AppEName; //因为赋值到这里是对的。用户名
                    zitem.AppID =
                      alltestArr[isouhe[x]].children[i].children[b].AppID; //赋予ID
                    zitem.AppName =
                      alltestArr[isouhe[x]].children[i].children[b].AppName; //赋予ID
                  }
                });
              }
            }
            return (
              alltestArr[isouhe[x]].children[i].AppClassName === item.label
            );
          });
          if (a.length != 0) {
            // console.log(selectarr[x],a[x],i);
            selectarr[x].children[i] = a[x];
          }
        }
      }
      //过滤传给第一级的数据
      let res = this.vals.map((item) => {
        return item.children.map((zitem) => {
          return zitem.children;
        });
      });
      res = res.flat(2);
      let CookieApp = {}; //智能组卷发送给④步的数据
      this.vals.map((item) => {
        item.children.map((zitem) => {
          CookieApp[`${zitem.label}`] = zitem.children;
        });
      });
      let softappdata = this.softapprrefer(this.vals);
      if (
        this.$parent.$parent.softAppdata === undefined &&
        this.$parent.$parent.isCollect === undefined
      ) {
        //这里在收藏题库组件中进行拦截，利用没有isCollect
        this.$parent.$parent.random_db_data.softApp = softappdata;
        this.$parent.$parent.random_db_data.CookieApp = CookieApp;
        this.$parent.$parent.random_Proportion_data.softApp = softappdata;
        this.$parent.$parent.random_Proportion_data.CookieApp = CookieApp;
      }
      this.$parent.$parent.softAppdata = softappdata;
      this.$parent.$parent.pagetworeq3 = CookieApp;
      this.$emit("totesttype", this.vals, res); //这里不能直接传值，这里的数据类型不够，要重新拼接数据。 但是暂时采用这种办法，这只是把视觉上的数据传值过去了，但是没有传APPClassID和AppClassName过来。
      //到这里，第二层数据已经改造ok。
      const arr = [];
      selectarr[0].children.forEach((item) => arr.push(item));
      console.log(this.val);
    },
    settestscope() {
      if (this.isdialogVisible == 1) {
        this.option = []; //还原初始数据。
        this.localStorageResouce = "alltestbank";
        this.option = JSON.parse(
          localStorage.getItem(this.localStorageResouce)
        );
        return;
      }
      this.option = []; //还原初始数据。
      this.localStorageResouce = "testbank";
      this.option = JSON.parse(localStorage.getItem(this.localStorageResouce));
    },
    // 11.21 添加搜索 props
    async queryClick() {
      if (this.queryTitle == "") {
        this.$message({
          message: "当前查询字段不能为空",
          type: "warning",
        });
      } else {
        let nerarr = JSON.parse(JSON.stringify(this.option));
        this.checkOptions = this.filterTree(nerarr, this.queryTitle);
        if (this.checkOptions.length == 0) {
          this.queryState = 2;
        } else {
          this.queryState = 1;
        }
      }
    },
    // 过滤查询的方法
    filterTree(arr, val) {
      let newarr = [];
      arr.forEach((item) => {
        if (item.children && item.children.length) {
          let children = this.filterTree(item.children, val);
          let obj = {
            ...item,
            children,
          };
          if (children && children.length) {
            newarr.push(obj);
          } else if (item.AppClassName.includes(val)) {
            newarr.push({ ...item });
          }
        } else {
          if (item.AppClassName.includes(val)) {
            newarr.push(item);
          }
        }
      });
      return newarr;
    },
    // 11.21 添加查询重置。需回显用户勾中的科目
    /*
     查询功能思路是 原数组A不动 ，根据搜索条件过滤出符合条件的B
     将得到符合条件的B数组插入级联模板达到显示查询结果
     当钩选中B数组的数据，在重置操作中遍历A数组，插入A进行去重

    */
    resetClick() {
      this.queryState = 0;
      this.queryTitle = "";
    },
    fn(name) {
      // 过滤匹配出当前所在的系列ID
      let newName = this.option.filter((item) => {
        return item.AppClassName == name;
      });
      if (newName.length != 0) {
        // 只匹配最外一层
        this.outeKey = newName[0].AppClassID || "";
      }
    },
    // 获取选中的数组 leafOnly 勾中的数据
    getnewValArr(leafOnly) {
      if (this.val == undefined) {
        this.val = [];
      }
      // 将查询勾中的和val整合
      this.val = this.val.concat(leafOnly);
    },
    changTape(type) {
      if (type == true) {
        // 展开时候的回调
        this.checkedCities = this.val; // 回显已勾中的
      }
    },
  },
  computed: {
    opentime() {
      return function () {
        if (this.queryState == 0) {
          return this.option; // 源数据 A数组
        } else if (this.queryState == 1) {
          return this.checkOptions; // 查询返回符合条件 B数组
        }
      };
    },
  },
  created() {
    this.settestscope();
    this.testtype = "0";
    this.outeKey = this.option[0].AppClassID; // 初始化
    if (this.$parent.$parent.testmode) {
      this.testmode = this.$parent.$parent.testmode;
    } else {
      this.testmode = this.$parent.$parent.$children[0].input1;
    }
    console.log(this.testmode);
  },
  mounted() {
    this.vals = totype.zhuanhuan(this.val);
  },
  watch: {
    // testtype 0 平台题库 1 自定义题库 2 收藏题库  AppClassID:-100 自定义题库 -200 收藏题库
    testtype(newvalue, oldvalue) {
      let newarr = JSON.parse(localStorage.getItem(this.localStorageResouce));
      if (newvalue === "0") {
        // this.option = newarr.slice(0, newarr.length - 2);
        this.option = newarr.filter((item) => {
          return item.AppClassID !== -100 && item.AppClassID !== -200;
        });
        this.val = this.modelval["0"];
      } else if (newvalue === "1") {
        // this.option = [newarr[newarr.length - 2]];
        this.option = newarr.filter((item) => {
          return item.AppClassID == -100;
        });
        this.val = this.modelval["1"];
      } else if (newvalue === "2") {
        // this.option = [newarr[newarr.length - 1]];
        this.option = newarr.filter((item) => {
          return item.AppClassID == -200;
        });
        this.val = this.modelval["2"];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  width: 80%;
  min-width: 1572px;
  background: #ffffff;
  border: 1px solid #707070;
  border-radius: 20px;
}
::v-deep .el-dialog__header {
  padding: 0 !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important ;
}
.dialog-title {
  display: flex;
  align-items: center;
  height: 55px;
  border-radius: 5px 5px 0px 0px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  h4 {
    margin-left: 30px;
    width: 72px;
    height: 30px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}
.dialogclose {
  cursor: pointer;
  margin-left: 1430px;
}
.dialog-body {
  background-color: none;
}
.testtypebutton {
  //height: 83px;
  background-color: rgb(255, 255, 255);
  //border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.testtypebtn {
  width: 180px;
  height: 50px;
  // padding-top: 5px;
  background: #ffffff;
  border: 1px solid #1890ff;
  font-family: PingFang SC;
  border: 1px solid#1890FF;
  border-radius: 5px 0px 0px 5px;
  &:nth-child(2) {
    border-radius: 0px 0px 0px 0px;
  }
  &:nth-child(3) {
    border-left: none;
    border-radius: 0px 5px 5px 0px;
  }
  //border-radius: 0px 5px 5px 0px;
}
.isactivetype {
  color: #ffffff;
  background-color: #1890ff;
}
.titlecontent {
  border-bottom: 1px solid #abd7ff;
  background-color: #eff7ff;
  display: flex;
  justify-content: space-between;
  align-content: center;
  .query {
    display: flex;
    padding: 10px;
    align-content: center;
    .el-button {
      height: 40px;
      &:nth-child(2) {
        background: #1890ff;
        color: #fff;
        margin-left: 6px;
      }
    }
  }
  h4 {
    //background-color: #1890ff;
    width: 100px;
    font-size: 18px;
    font-family: PingFang SC;
    color: #333333;
    padding: 10px 10px 15px 10px;
  }
}
.question_contents {
  display: flex;
  .questions {
    width: 49%;
    // border-top: 1px solid #abd7ff;
  }
  .question {
    width: 2%;
    height: 480px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .questionsyixuan {
    ::v-deep .el-cascader-panel {
      background-color: #f1f8ff;
    }
  }
  .resreach {
    height: 50px;
    font-size: 14px;
    //background: #cce7ff;
    font-family: PingFang SC;
    font-weight: bold;
    //   line-height: 19px;
    color: #333333;
    //  line-height: 60px;
    //padding-left: 14px;
    display: flex;
    // justify-content: space-around;
    align-items: center;
    // background-color: #8fcaff;
    .resreach_item {
      height: 100%;
      padding-left: 45px;
      line-height: 50px;
      min-width: 15.625rem;
      width: 30%;
      background-color: #f1f8ff;
      border: 1px solid #eeeeee;
    }
    .resreach_item3 {
      height: 100%;
      width: 33%;
      min-width: 15.625rem;
      // border-right: 10px solid #1890FF;
    }
    .resreach_item4 {
      width: 2%;
      height: 100%;
      background-color: #1890ff;
    }
  }
}
::v-deep .is-bordered {
  > :nth-child(1) {
    min-width: 250px;
    width: 30%;
    border-right: none;
  }
  > :nth-child(2) {
    min-width: 250px;
    width: 30%;
    border-right: none;
  }
  > :nth-child(3) {
    min-width: 250px;
    width: 33%;
    border-right: none;
  }
}

::v-deep .el-cascader-menu__wrap {
  height: 430px;
}
::v-deep .el-cascader-node {
  height: 52px;
  border-bottom: 1px solid #eeeeee;
  &:focus {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
  }
  &:hover {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
  }
}
::v-deep .el-icon-arrow-right {
  display: none; //向右的箭头隐藏
}
::v-deep .el-cascader-menu__list {
  border-right: 1px solid #eeeeee;
}
::v-deep .in-active-path {
  //更改选中后的属性
  background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
}
.operation_btn {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-content: center;
  margin-bottom: 20px;
  .el-button {
    width: 108px;
    height: 50px;
    border-radius: 4px;
  }
  .el-button:nth-child(1) {
    background: #eeeeee;
    border: none;
  }
  .el-button:nth-child(2) {
    background: #1890ff;
    margin-left: 90px;
  }
}
.null_view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}
.checkbox {
  padding: 24px;
}
.taansferssss {
  color: red;
  ::v-deep .el-cascader__tags .el-tag {
    display: none !important;
  }
  ::v-deep .el-input__icon {
    display: none; // 隐藏关闭图标
  }
}
::v-deep .el-cascader-node__label {
  white-space: normal;
}
::v-deep .el-cascader-node {
  height: 100%;
  padding: 10px;
}
</style>
<style lang='scss'>
.tranoptions {
  // background-color: red !important;
  .el-cascader-panel {
    display: none !important;
  }
  .el-cascader__suggestion-panel {
    display: block !important;
  }
}
</style>